import { render } from "./NotFound.vue?vue&type=template&id=c7a6e986"
const script = {}

import exportComponent from "C:\\_GIT\\general\\Gazi\\GaziVue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__